import { axiosInstance as axios } from 'Api'
import { handlingResponse, urlEncoded } from 'Utility/globalMethods'
/* eslint-disable global-require */
if (process.env.ISMOCK) {
  require('Mocks/changePassword/changePassword')
}

export async function callChangePassword(params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: `${process.env.AUTHORIZATION_API}change-password`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: urlEncoded(params)
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

// @generator api:method
